import { removeDomainAsync } from '../actions';
import { DomainsActions, DomainsState } from '../types';
import { getType } from '@anm/helpers/saga/typesafe-actions';
import { Reducer } from 'redux';

import { initialDomainsState } from '.';

const removeDomainReducer: Reducer<DomainsState, DomainsActions> = (state = initialDomainsState, action) => {
  switch (action.type) {
    case getType(removeDomainAsync.request): {
      return {
        ...state,
        removeDomain: {
          ...state.removeDomain,
          isPending: true,
          params: {
            domain: action.payload
          }
        }
      };
    }
    case getType(removeDomainAsync.success): {
      const filteredList = (state.list || []).filter(i => i.Host !== state.removeDomain.params.domain);

      return {
        ...state,
        list: filteredList,
        removeDomain: {
          ...state.removeDomain,
          isPending: false
        }
      };
    }
    case getType(removeDomainAsync.failure): {
      return {
        ...state,
        removeDomain: {
          ...state.removeDomain,
          isPending: false,
          isError: true,
          error: action.payload
        }
      };
    }

    default:
      return state;
  }
};

export default removeDomainReducer;
